/**
 * Shared typograf from kolomatskiy.ru: non-breaking spaces after short words
 * and numbers, so «в», «и», «12» don't hang at line ends.
 *
 * Loaded at runtime, like the Telegram SDK: if the host is unreachable, the
 * app still opens and texts simply go out as written.
 */

const TYPOGRAF_URL = 'https://kolomatskiy.ru/static/lib/typograf/v1/typograf.js'
const TYPOGRAF_TIMEOUT_MS = 1000

interface TypografModule {
  fixTypography(input: string, lang?: 'ru' | 'en', options?: { trailingPeriod?: 'strip-single' | 'keep' }): string
}

let fix: ((text: string) => string) | null = null

/** Resolves once typograf is loaded, failed, or timed out — never rejects. */
export const typografReady: Promise<void> = Promise.race([
  import(/* @vite-ignore */ TYPOGRAF_URL)
    .then((module: TypografModule) => {
      // Final periods are fixed in the texts themselves: code glues some strings
      // into longer sentences, and a stripped period would be lost there
      fix = (text) => module.fixTypography(text, 'ru', { trailingPeriod: 'keep' })
    })
    .catch(() => {}),
  new Promise<void>((resolve) => setTimeout(resolve, TYPOGRAF_TIMEOUT_MS)),
])

export function typo(text: string): string {
  return fix && text ? fix(text) : text
}
